import { Dispatch, SetStateAction } from 'react';
import { UserType } from '../../../api/types/user/user-type';
import { AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import appApi from '../../../api/app-api';
import { SearchUserType } from '../types/search-user-type';
import globalConfigStore from '../../../stores/global-config-store';
import globalSettingsBranches from '../../../stores/global-settings-branches';

export const findUserOperation = async (
  event: AutoCompleteCompleteEvent,
  setFilteredUsers: Dispatch<SetStateAction<SearchUserType[]>>,
  setLoading: (loading: boolean) => void,
  role?: UserType,
) => {
  const query = event.query.toLocaleLowerCase();
  console.log('The query is: ' + query);
  if (query.length < 2) {
    return;
  }
  setLoading(true);
  const branchIds = globalSettingsBranches.branches.map((item) => item.id);
  const searchedUsers = await appApi.searchForUsers(branchIds, query, role);
  setLoading(false);
  const searchedUserType = searchedUsers.data.body.map(
    (userItem) =>
      ({
        ...userItem,
        label: `${userItem.firstName} ${userItem.lastName} ${userItem.nationalId}`,
      }) as SearchUserType,
  );

  if (role) {
    const filterByRole = searchedUserType.filter((item) => item.role === role);
    setFilteredUsers(filterByRole);
  } else {
    setFilteredUsers(searchedUserType);
    setLoading(false);
  }
};
